/**
 * Payment methods and tokenization error codes.
 */
export enum PaymentErrorCode {
  GATEWAY_CONFIG_FAILED = 'error.payment.gateway_config.failed',
  GATEWAY_TOKEN_FAILED = 'error.payment.gateway_token.failed',
  TOKENIZATION_FAILED = 'error.payment.tokenization.failed',
  COMPONENT_LOAD_FAILED = 'error.payment.component_load.failed',
  INTENT_CREATE_FAILED = 'error.payment.intent_create.failed',
  INTENT_UPDATE_FAILED = 'error.payment.intent_update.failed',
  CHARGEBEE_JS_LOAD_FAILED = 'error.payment.chargebee_js_load.failed',
  CHARGEBEE_JS_COMPONENT_LOAD_FAILED = 'error.payment.chargebee_js_component_load.failed',
}
